export default __webpack_public_path__ + "static/media/upload.ce87796c.svg";